import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Group, Radio, Title, factory, useStyles, useProps } from "@mantine/core";
import classes from "./RadioCard.module.css";
var defaultProps = {};
export var RadioCard = factory(function(_props, ref) {
    var _ref = useProps("RadioCard", defaultProps, _props), classNames = _ref.classNames, styles = _ref.styles, style = _ref.style, className = _ref.className, vars = _ref.vars, disabled = _ref.disabled, label = _ref.label, description = _ref.description, others = _object_without_properties(_ref, [
        "classNames",
        "styles",
        "style",
        "className",
        "vars",
        "disabled",
        "label",
        "description"
    ]);
    var getStyles = useStyles({
        name: "RadioCard",
        classes: classes,
        vars: vars,
        classNames: classNames,
        className: className,
        style: style,
        props: _props,
        styles: styles
    });
    return /*#__PURE__*/ _jsxs(Radio.Card, _object_spread_props(_object_spread({
        ref: ref,
        disabled: disabled
    }, getStyles("card", {
        className: className,
        style: style,
        classNames: classNames,
        styles: styles
    }), others), {
        children: [
            /*#__PURE__*/ _jsxs(Group, _object_spread_props(_object_spread({}, getStyles("container", {
                classNames: classNames,
                styles: styles
            })), {
                children: [
                    /*#__PURE__*/ _jsx(Radio.Indicator, _object_spread({
                        size: "xs",
                        disabled: disabled
                    }, getStyles("indicator", {
                        classNames: classNames,
                        styles: styles
                    }))),
                    /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({
                        order: 4
                    }, getStyles("title", {
                        classNames: classNames,
                        styles: styles
                    })), {
                        children: label
                    }))
                ]
            })),
            /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, getStyles("description", {
                classNames: classNames,
                styles: styles
            })), {
                children: description
            }))
        ]
    }));
});

//# sourceMappingURL=RadioCard.js.map